import { SVGProps, Ref, forwardRef } from "react";

const ArrowUpIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Arrow Up Icon"
    strokeWidth={2}
    {...props}
  >
    <title id="Arrow Up Icon">Arrow Up Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 19V5m0 0-7 7m7-7 7 7"
    />
  </svg>
);

const ForwardRef = forwardRef(ArrowUpIcon);

export default ForwardRef;
